module.exports = __webpack_public_path__ + "img/thumb_13.3758bdc3.jpg";